import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalPlayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_play"}/>
}
